<template>
  <div class="comm_scrInput_wrap">
    <div>
      <sui-text-field
        ref="inputField"
        v-model="companyData.companyName"
        :maxlength="maxlength"
        :readonly="readonly"
        :placeholder="placeholder"
        style="width:100%;"
        fixedIcon
        @clear-input="reset"
      />
    </div>
    <sui-button
      type="button"
      class="comm_btn_InputScr"
      @click="onSearchClick"
    />
  </div>
</template>
<script>
export default {
  name: 'CmpVendorSelect',
  props: {
    selectedCompany: {
      type: Object,
      default() {
        return {
          companyName: '',
          companyId: '',
        };
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      companyData: this.selectedCompany,
    };
  },
  methods: {
    onSearchClick() {
      utils.openLayerPopup('PGE_CMY_00014', this.onCompanyPopupCallback, {
        pageInitialData: {},
        size: 'xlg',
      });
    },
    onCompanyPopupCallback(nodeData) {
      if (!utils.isEmpty(nodeData)) {
        this.companyData.companyName = nodeData[0].companyName;
        this.companyData.companyId = nodeData[0].companyId;

        this.$emit('selected', this.companyData);
      }
    },
    focus() {
      this.$refs.inputField.setFocus();
    },
    reset() {
      this.companyData.companyId = '';
      this.companyData.companyName = '';
      this.$emit('selected', this.companyData);
    },
  },
};
</script>
<style scoped>
</style>
